/**
 * Input Component - HELIX Professional Design System v9.2.1
 *
 * Styling per Executive OS:
 * - Padding: 8px 14px
 * - Background: bgSubtle (#F4F5F7)
 * - Border: border (#E1E4E8)
 * - Focus: borderFocus (#4A6FA5) + shadow.focus
 */

import * as React from 'react';
import { cn } from '@/lib/cn';

type InputSize = 'sm' | 'md' | 'lg';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputSize?: InputSize;
}

const sizeClasses: Record<InputSize, string> = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-9 px-[14px] text-sm',
  lg: 'h-10 px-4 text-sm',
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, inputSize = 'md', ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        // Base styles
        'flex w-full rounded-md border border-input bg-secondary',
        // Typography
        'placeholder:text-muted-foreground',
        // Focus ring: uses primary (muted blue)
        'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        // Disabled state
        'disabled:cursor-not-allowed disabled:opacity-50',
        // Size
        sizeClasses[inputSize],
        className,
      )}
      {...props}
    />
  );
});
